import ReconnectingWebSocket from "reconnecting-websocket";
// import { WebSocketUrl } from "../config/index";
import store from "../store/index";
import {
  selectPackageListByQuery,
  //   queryOrderByUseId,
  getMinChatLinkCountsServiceIp,
} from "../network/api";
import { ElNotification, ElMessage } from "element-plus";
import Company from "../config";
import { mapState } from 'vuex';
import { Howl } from 'howler';

var sound = null;

export default {
  computed: {
    ...mapState([
      'showVideoChatData',
      'websocket',
      'srcObj',
      'rmSrcObj',
      'peer',
    ]),
    showVideoChatDataValue: {
      get() {
        return this.showVideoChatData; // 从 Vuex 获取值
      },
      set(value) {
        store.commit('setShowVideoChatData', value); // 更新 Vuex 中的值
      }
    },
    websocketValue: {
      get() {
        return this.websocket; // 从 Vuex 获取值
      },
      set(value) {
        store.commit('setWebsocket', value); // 更新 Vuex 中的值
      }
    },
    srcObjValue: {
      get() {
        return this.srcObj; // 从 Vuex 获取值
      },
      set(value) {
        store.commit('setSrcObj', value); // 更新 Vuex 中的值
      }
    },
    rmSrcObjValue: {
      get() {
        return this.rmSrcObj; // 从 Vuex 获取值
      },
      set(value) {
        store.commit('setRmSrcObj', value); // 更新 Vuex 中的值
      }
    },
    peerValue: {
      get() {
        return this.peer; // 从 Vuex 获取值
      },
      set(value) {
        store.commit('setPeer', value); // 更新 Vuex 中的值
      }
    }
  },
}

export const InitWebSocket = () => {
  store.commit("setCalling", false);
  const user = JSON.parse(localStorage.getItem("userInfo"));
  let toUser = 0;
  const reateLinkAndSendheartBeat = () => {
    let message = initNullMessagePojo();
    message.type = "create_link";
    store.state.websocket.send(JSON.stringify(message));
    setInterval(() => {
      let _message = initNullMessagePojo();
      _message.type = "heartbeat_check";
      store.state.websocket.send(JSON.stringify(_message));
    }, 10000);
  };

  const initAudioPlayer = () => {
    sound = new Howl({
      src: [require('@/assets/audio/drivier_call.mp3')], // 声音文件路径，支持多个格式以增强兼容性
      loop: true, // 设置声音循环播放
      volume: 0.5, // 设置音量，0到1之间
      onend: () => { // 声音播放结束时的回调（理论上不会触发，因为设置了loop）
        // console.log('Sound ended');
      },
      onload: () => { // 声音加载完成后的回调
        // console.log('Sound loaded');
      }});
  }

  const initNullMessagePojo = () => {
    let cfUserMessage = {
      id: "",
      fromUid: "",
      toUid: "",
      groupId: "",
      status: 0,
      contents: "",
      type: 0,
      client: "",
      ip: "",
      createTime: 0,
      receiveTime: 0,
    };

    let message = {
      type: "",
      cfUserMessage: cfUserMessage,
      ext: "",
      token: localStorage.getItem("token"),
    };
    return message;
  };

  // 向Store推送消息
  const pushStoreData = (data, type) => {
    const carParkId = data.carParkId;
    if (type === "out") store.commit("SETOUT", data);
    if (type === "in") store.commit("SETIN", data);
    // 判断是用来选择哪个停车场 就推哪个停车场的图片
    if (carParkId === store.getters.carParkId) {
      if (type === "out") {
        store.commit("SETOUTIMAGE", {
          outImage: data.outBigImageUrl,
          outSmallImage: data.outSmallImageUrl,
        });
      } else {
        store.commit("SETINIMAGE", {
          inImage: data.inBigImageUrl,
          inSmallImage: data.inSmallImageUrl,
        });
      }
    }
  };
  // 获取账单信息
  // const getQueryOrderByUseId = async (carParkUseLog) => {
  //     const { data, code } = await queryOrderByUseId(carParkUseLog.id);
  //     if (code != 10002) return
  //     if(store.state.globalConfig.promptChargeOutCar){
  //         if(data.cfOrder.amountsPayable > 0){
  //             pushStoreData(data,'out')
  //         }
  //     }else{
  //         pushStoreData(data,'out')
  //     }

  //     if (data.cfCouponList != "" && data.cfCouponList.length > 0) {
  //         data.cfOrder.couponDenomination =
  //             data["cfCouponList"][0]["denomination"];
  //     } else {
  //         data.cfOrder.couponDenomination = 0;
  //     }

  //     if (
  //         data.cfOrder.amountsPayable - data.cfOrder.couponDenomination > 0 &&
  //         data.cfOrder.status == 0 &&
  //         !data.cfOrder.collectionShopId && data.cfOrder.payTime === 0 && carParkUseLog.payTime === 0
  //     ) {
  //         console.log('被收费的车俩',data);
  //         store.commit('SETCHARGECAR', data)
  //     }
  // }

  const pushOut = (carParkUseLog) => {
    if (store.state.globalConfig.promptChargeOutCar) {
      if (carParkUseLog.cfOrder.amountsPayable > 0) {
        pushStoreData(carParkUseLog, "out");
      }
    } else {
      pushStoreData(carParkUseLog, "out");
    }
    if (
      carParkUseLog.cfOrder.amountsPayable>0 &&
      carParkUseLog.cfOrder.status == 0 &&
      carParkUseLog.payTime == 0
    ) {
      store.commit("SETCHARGECAR", carParkUseLog);
    }
  };

  const updateInterface = async (message) => {
    // console.log("心跳收到的消息", JSON.parse(message.cfUserMessage.contents));
    if (message == null) return;
    //修改消息状态为已读
    let consumptionData = initNullMessagePojo();
    consumptionData.type = "change_status";
    consumptionData.cfUserMessage.id = message.cfUserMessage.id;

    consumptionData.cfUserMessage.toUid = message.cfUserMessage.toUid;
    store.state.websocket.send(JSON.stringify(consumptionData));
    // 将数据放到页面中进行展示
    let carParkUseLog = JSON.parse(message.cfUserMessage.contents);
    // console.log(carParkUseLog,'carParkUseLog');
    if (message.cfUserMessage.type == 1) {
      if (carParkUseLog.inTime > 0 && carParkUseLog.outTime == 0) {
        // this.nowInBigImage = carParkUseLog.inBigImage;
        const { data } = await selectPackageListByQuery({
          carParkId: carParkUseLog.carParkId,
          numberPlate: carParkUseLog.numberPlate,
        });
        carParkUseLog.cfCarParkCarType =
          data == null
            ? { name: "临时车", flagKey: "temporary_car" }
            : data[0].cfCarParkCarType;
        // console.log("查询车辆的套餐", data, code);
        pushStoreData(carParkUseLog, "in");
      }
      // 更新界面:包括 图片 消息 更新到页面
      // 只提示选中停车场的停车数据
      if (carParkUseLog.carParkId == store.getters.carParkId) {
        const direction =
          carParkUseLog.outTime == 0 ? " 车牌进场：" : "车牌出场：";
        const outCheckPointName = carParkUseLog.outTime == 0 ? carParkUseLog.inCheckPointName : carParkUseLog.outCheckPointName;
        if (store.state.globalConfig.promptEntryExitCar) {
          ElNotification({
            title: "提示",
            message:
              outCheckPointName +
              direction +
              carParkUseLog?.numberPlate,
            position: "bottom-left",
            type: "warning",
          });
        }
      }

      // 出场查询账单
      if (carParkUseLog.outTime > 0) {
        // getQueryOrderByUseId(carParkUseLog);
        pushOut(carParkUseLog);
      }
    } else if (message.cfUserMessage.type == 13) {
      //无入场记录模糊匹配
      store.commit("SetLicenseplateCorrection", {
        show: true,
        data: message,
      });
    } else if (message.cfUserMessage.type == 2) {
      // 用户已支付 取消弹窗
      console.log("已支付的车辆信息", carParkUseLog);
      store.commit("PAIDCAR", carParkUseLog);
      // this.$refs.ChargeBox.deleteData(carParkUseLog);
    }
  };

  const WebRTCInit = async () => {
    // RTCPeerConnection 的配置，内网时不需要开启stun、turn
    const defaultConfiguration = {
      bundlePolicy: "max-bundle",
      rtcpMuxPolicy: "require",
      iceTransportPolicy: "all", // relay：如果使用了turn建议使用relay
      // ice
      iceServers: [
        {
          urls: [
            "turn:47.96.179.185:3478?transport=udp",
            "turn:47.96.179.185:3478?transport=tcp",
          ],
          username: "cfzh",
          credential: "gB6TA6dSVdN5uY9xP1r0",
        },
        {
          urls: ["stun:47.96.179.185:3478"],
        },
      ],
    };
    var Rtc =
        window.RTCPeerConnection ||
        window.webkitRTCPeerConnection ||
        window.mozRTCPeerConnection;
    if (!Rtc) {
      alert("不支持WebRTC");
    }
    store.commit("setPeer", new RTCPeerConnection(defaultConfiguration));
    // peer = new RTCPeerConnection();
    //ice
    store.state.peer.onicecandidate = (e) => {
      if (e.candidate) {
        // alert("开始拼接数据"+JSON.stringify(e.candidate))
        try {
          let cfUserMessage = {
            id: "",
            fromUid: "",
            toUid: toUser,
            groupId: "",
            status: 0,
            contents: {
              toUser: toUser,
              fromUser: user.id,
              iceCandidate: e.candidate,
            },
            type: 0,
            client: "",
            ip: "",
            createTime: 0,
            receiveTime: 0,
          };

          let message = {
            type: "_ice",
            cfUserMessage: cfUserMessage,
            ext: "",
          };
          store.state.websocket.send(JSON.stringify(message));
        } catch (ex) {
          alert("出现异常" + ex.message);
        }
      }
    };

    //track
    store.state.peer.ontrack = (e) => {
      if (e && e.streams) {
        store.commit("setRmSrcObj", e.streams[0]);
      }
    };
  };

  const handleHangupClick = async () => {
    if (store.state.srcObj) {
      const videoTracks = store.state.srcObj.getVideoTracks();
      videoTracks.forEach((videoTrack) => {
        videoTrack.stop();
        store.state.srcObj.removeTrack(videoTrack);
      });
    }

    if (store.state.rmSrcObj) {
      const videoTracks = store.state.rmSrcObj.getVideoTracks();
      videoTracks.forEach((videoTrack) => {
        videoTrack.stop();
        store.state.rmSrcObj.removeTrack(videoTrack);
      });
    }

    if (store.state.peer) {
      store.state.peer.ontrack = null;
      store.state.peer.onremovetrack = null;
      store.state.peer.onremovestream = null;
      store.state.peer.onicecandidate = null;
      store.state.peer.oniceconnectionstatechange = null;
      store.state.peer.onsignalingstatechange = null;
      store.state.peer.onicegatheringstatechange = null;
      store.state.peer.onnegotiationneeded = null;

      store.state.peer.close();
      store.commit("setPeer", null);
    }
    store.commit("setSrcObj", null);
    store.commit("setRmSrcObj", null);
    store.commit("setShowVideoChatData", false);
    store.commit("setCalling", false);
  }

  const handleType = async (message) => {
    let type = message.type;
    let cfUserMessage = message.cfUserMessage;
    if (type === "off_line") {
      alert("对方不在线");
      return;
    }else if (type === "hangup") {
      // alert("对方已经挂断");
      handleHangupClick();
      return;
    }else if (type === "call_start") {
      toUser = cfUserMessage.fromUid;

      if(store.state.calling){
        //说明正在通话，拒绝其他人
        let _cfUserMessage = {
          id: "",
          fromUid: "",
          toUid: cfUserMessage.fromUid,
          groupId: "",
          status: 0,
          contents: "-1",
          type: 0,
          client: "",
          ip: "",
          createTime: 0,
          receiveTime: 0,
        };

        let message = {
          type: "call_back",
          cfUserMessage: _cfUserMessage,
          ext: "",
          token: localStorage.getItem("token"),
        };
        store.state.websocket.send(JSON.stringify(message));
        return;
      }


      // sound.play(); //播放提示声音

      // msg = 0 表示拒绝，1表示同意
      let msg = "0";
      store.commit("setShowVideoChatData", true);
      store.commit("setCallingCheckPoint", JSON.parse(cfUserMessage.contents));
      if (confirm("确定接听吗") == true) {
        WebRTCInit();
        msg = "1";
      }
      sound.stop(); //关闭提示声音
      store.commit("setCalling", true);

      let _cfUserMessage = {
        id: "",
        fromUid: "",
        toUid: cfUserMessage.fromUid,
        groupId: "",
        status: 0,
        contents: msg,
        type: 0,
        client: "",
        ip: "",
        createTime: 0,
        receiveTime: 0,
      };

      let message = {
        type: "call_back",
        cfUserMessage: _cfUserMessage,
        ext: "",
        token: localStorage.getItem("token"),
      };
      store.state.websocket.send(JSON.stringify(message));

      return;
    }else if (type === "call_back") {
      if (cfUserMessage.contents === "1") {
        try {
          // alert(cfUserMessage.toUid + "同意视频通话");

          //创建本地视频并发送offer
          let stream = await navigator.mediaDevices.getUserMedia({
            video: true,
            audio: true,
          });
          store.commit("setSrcObj", stream);
          stream.getTracks().forEach((track) => {
            store.state.peer.addTrack(track, stream);
          });

          let offer = await store.state.peer.createOffer();
          await store.state.peer.setLocalDescription(offer);
          // alert("发送的offer数据"+JSON.stringify(offer));
          let newOffer = JSON.parse(JSON.stringify(offer));
          // alert("发送的offer数据中的sdp"+JSON.stringify(offer.sdp));
          newOffer["fromUser"] = user.id;
          newOffer["toUser"] = cfUserMessage.fromUid;

          let _cfUserMessage = {
            id: "",
            fromUid: "",
            toUid: cfUserMessage.fromUid,
            groupId: "",
            status: 0,
            contents: newOffer,
            type: 0,
            client: "",
            ip: "",
            createTime: 0,
            receiveTime: 0,
          };

          let message = {
            type: newOffer.type,
            cfUserMessage: _cfUserMessage,
            ext: "",
            token: "",
          };
          store.state.websocket.send(JSON.stringify(message));
        } catch (error) {
          alert("接收同意通话出现异常" + error.message);
        }
      } else if (cfUserMessage.contents === "0") {
        alert(cfUserMessage.toUid + "拒绝视频通话");
        handleHangupClick();
      } else {
        alert(cfUserMessage.contents);
        handleHangupClick();
      }

      return;
    }else if (type === "offer") {
      try {
        let stream = await navigator.mediaDevices.getUserMedia({
          video: true,
          audio: true,
        });
        store.commit("setSrcObj", stream);
        stream.getTracks().forEach((track) => {
          store.state.peer.addTrack(track, stream);
        });
        // alert("接收到的offer数据" + JSON.stringify(cfUserMessage.contents));
        let sdp = JSON.parse(cfUserMessage.contents).sdp;
        // alert("接收到的sdp值" + sdp);
        await store.state.peer.setRemoteDescription(
            new RTCSessionDescription({ type, sdp })
        );
        let answer = await store.state.peer.createAnswer();
        let newAnswer = JSON.parse(JSON.stringify(answer));

        newAnswer["fromUser"] = user.id;
        newAnswer["toUser"] = cfUserMessage.fromUid;

        let _cfUserMessage = {
          id: "",
          fromUid: "",
          toUid: cfUserMessage.fromUid,
          groupId: "",
          status: 0,
          contents: newAnswer,
          type: 0,
          client: "",
          ip: "",
          createTime: 0,
          receiveTime: 0,
        };

        let message = {
          type: newAnswer.type,
          cfUserMessage: _cfUserMessage,
          ext: "",
          token: "",
        };
        store.state.websocket.send(JSON.stringify(message));
        // alert("发送的answer数据" + JSON.stringify(message));
        await store.state.peer.setLocalDescription(answer);
        return;
      } catch (error) {
        alert("接收offer数据出现异常" + error.message);
      }
    }else if (type === "answer") {
      try {
        // alert('接收answer数据'+JSON.stringify(cfUserMessage))

        let sdp = JSON.parse(cfUserMessage.contents).sdp;
        // alert('接收answer数据是的sdp'+sdp)
        store.state.peer.setRemoteDescription(
            new RTCSessionDescription({ type, sdp })
        );
      } catch (error) {
        alert("接收answer数据出现异常" + error.message);
      }
      return;
    }else if (type === "_ice") {
      try {
        console.log('_ice接收数据',JSON.parse(cfUserMessage.contents))
        let iceCandidate = JSON.parse(cfUserMessage.contents).iceCandidate;
        store.state.peer.addIceCandidate(iceCandidate);
      } catch (error) {
        alert("_ice接收出现异常" + error.message);
      }
      return;
    } else {
      // 将数据放到页面中进行展示
      updateInterface(message);
    }
  };

  if (window.WebSocket) {
    getMinChatLinkCountsServiceIp().then((res) => {
      if (res.code != 10002) {
        ElMessage.error(res.message);
        return;
      }
      let websocket = new ReconnectingWebSocket(Company.wssUrl+'/ws');
      store.commit("setWebsocket", websocket);
      websocket.onopen = (e) => {
        console.log("账单WebSocket连接开启", e);
        reateLinkAndSendheartBeat();
      };

      // 接受webSocket消息
      websocket.onmessage = (e) => {
        var message = JSON.parse(e.data);
        handleType(message);
      };

      websocket.onclose = (e) => {
        console.log(e);
      };
    });
    initAudioPlayer();
  } else {
    alert("您的浏览器不支持webSocket！");
  }
};
